import React from 'react'
import PropType from 'prop-types'
import { IntlProvider } from 'react-intl'
import { RootLayout } from '../layout/jss'

const locale = 'de'
  || (navigator.languages && navigator.languages[0])
  || navigator.language
  || navigator.userLanguage

function InfraNoAuthLayer({
  children, theme, message,
}) {
  return (
    <IntlProvider locale={locale} messages={message}>
      <RootLayout theme={theme}>
        { children }
      </RootLayout>
    </IntlProvider>
  )
}

InfraNoAuthLayer.propTypes = {
  children: PropType.node.isRequired,
  theme: PropType.oneOfType([PropType.object, PropType.string]).isRequired,
  message: PropType.objectOf(PropType.any).isRequired,
}

export default InfraNoAuthLayer
